import React from 'react';
import { Form, Select, Input, Row, Col } from 'antd';

const { Option } = Select;

const BannerForm = ({ 
  form, 
  countries, 
  salesChannels, 
  videoShows, 
  tvShows, 
  languages,
  onBannerTypeChange,
  onShowTypeChange,
  children 
}) => {
  return (
    <div>
      {/* Country Selection */}
      <Form.Item
        label="Country"
        name="country_id"
        rules={[{ required: true, message: 'Please select a country' }]}
      >
        <Select placeholder="Please select a country">
          {countries.map(country => (
            <Option key={country.country_id} value={country.country_id}>
              {country.country_name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      {/* Banner Name */}
      <Form.Item
        label="Banner Name"
        name="banner_name"
        rules={[{ required: true, message: 'Please enter banner name' }]}
      >
        <Input placeholder="Enter banner name" />
      </Form.Item>

      {/* Page Visibility Options */}
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label="Show on Home Page"
            name="home_page"
            rules={[{ required: true, message: 'Please select' }]}
          >
            <Select>
              <Option value="Y">Yes</Option>
              <Option value="N">No</Option>
            </Select>
          </Form.Item>
        </Col>
        
        <Col span={8}>
          <Form.Item
            label="Show on Movie Page"
            name="movie_page"
            rules={[{ required: true, message: 'Please select' }]}
          >
            <Select>
              <Option value="Y">Yes</Option>
              <Option value="N">No</Option>
            </Select>
          </Form.Item>
        </Col>
        
        <Col span={8}>
          <Form.Item
            label="Show on Series Page"
            name="series_page"
            rules={[{ required: true, message: 'Please select' }]}
          >
            <Select>
              <Option value="Y">Yes</Option>
              <Option value="N">No</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>

      {/* Banner Type */}
      <Form.Item
        label="Banner Type"
        name="m_banner_type"
        rules={[{ required: true, message: 'Please select banner type' }]}
      >
        <Select 
          placeholder="Please select banner type"
          onChange={onBannerTypeChange}
        >
          <Option value="generic">Generic</Option>
          <Option value="show">Show</Option>
          <Option value="promotion">Promotion</Option>
        </Select>
      </Form.Item>

      {/* Show Type - Only show when banner type is 'show' */}
      {form.m_banner_type === 'show' && (
        <Form.Item
          label="Show Type"
          name="show_type"
          rules={[{ required: true, message: 'Please select show type' }]}
        >
          <Select 
            placeholder="Please select show type"
            onChange={onShowTypeChange}
          >
            <Option value="movie">Movie</Option>
            <Option value="series">Series</Option>
          </Select>
        </Form.Item>
      )}

      {/* Show Selection - Only show when banner type is 'show' and show type is selected */}
      {form.m_banner_type === 'show' && form.show_type && (
        <Form.Item
          label={`Select ${form.show_type === 'movie' ? 'Movie' : 'Series'}`}
          name="show_id"
          rules={[{ required: true, message: `Please select a ${form.show_type}` }]}
        >
          <Select placeholder={`Please select ${form.show_type}`}>
            {form.show_type === 'movie' 
              ? videoShows.map(show => (
                  <Option key={show.video_show_id} value={show.video_show_id}>
                    {show.video_show_title}
                  </Option>
                ))
              : tvShows.map(show => (
                  <Option key={show.tv_show_id} value={show.tv_show_id}>
                    {show.tv_show_name}
                  </Option>
                ))
            }
          </Select>
        </Form.Item>
      )}

      {/* Language Selection - Only show when banner type is 'show' */}
      {form.m_banner_type === 'show' && (
        <Form.Item
          label="Choose Language"
          name="lang_id"
        >
          <Select placeholder="Please select a language">
            {languages.map(language => (
              <Option key={language.lang_id} value={language.lang_id}>
                {language.lang_name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      )}

      {/* Sales Channel */}
      <Form.Item
        label="Sales Channel"
        name="sales_channel"
      >
        <Select
          mode="multiple"
          placeholder="Please select channels"
        >
          {salesChannels.map(channel => (
            <Option key={channel.sc_id} value={channel.sc_id}>
              {channel.sc_name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      {/* Order */}
      <Form.Item
        label="Order of Banner"
        name="order"
      >
        <Input placeholder="Enter Order of Banner" type="number" />
      </Form.Item>

      {/* Banner Status */}
      <Form.Item
        label="Banner Status"
        name="banner_is_active"
        rules={[{ required: true, message: 'Please select banner status' }]}
      >
        <Select placeholder="Please select banner status">
          <Option value="Y">Active</Option>
          <Option value="N">Inactive</Option>
        </Select>
      </Form.Item>

      {/* Content Type */}
      <Form.Item
        label="Content Type"
        name="content_type"
        initialValue={1}
      >
        <Input type="number" disabled />
      </Form.Item>

      {/* Children components (Image Uploads) */}
      {children}
    </div>
  );
};

export default BannerForm;